import { usePlan, usePlans } from 'utils/hooks';
import { Button } from 'components';

function ManagePlan() {
    const plans = usePlans();
    const plan = usePlan();

    const isLoading = plan.isLoading || plans.isLoading;
    const hasError = plan.error || plans.error;

    if (hasError && !isLoading)
        return (
            <span>
                There was an error loading the plans.&nbsp;
                <Button
                    onClick={() => {
                        if (plan.error) plan.refetch();
                        if (plans.error) plans.refetch();
                    }}
                    type="button"
                >
                    Retry
                </Button>
            </span>
        );

    return (
        <>
            <label
                htmlFor="plans"
                css={`
                    position: static;
                    font-size: inherit;
                    color: inherit;
                    font-weight: inherit;
                    margin-right: ${({ theme }) => theme.space_4}px;

                    &::after {
                        content: ':';
                    }
                `}
            >
                Change Plan
            </label>
            <select
                name="plans"
                value={
                    plan.plan
                        ? plan.plan.id
                        : isLoading
                          ? 'loading'
                          : hasError
                            ? 'error'
                            : ''
                }
                onChange={(e) =>
                    plan.setPlan(
                        plans.data.find(({ id }) => id === e.target.value),
                    )
                }
                disabled={!(plan.plan && plans.data)}
            >
                {isLoading && (
                    <option key="loading" value="loading">
                        -- Loading Plans... --
                    </option>
                )}
                {!hasError && !isLoading && plans.data
                    ? plans.data.map(({ id, name }) => (
                          <option key={id} value={id}>
                              {name}
                          </option>
                      ))
                    : null}
            </select>
        </>
    );
}

export default ManagePlan;
